import { mergeDeep } from 'remeda';
import type { CardState, StoreState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';
import { setPath } from '../utils/set-path';

/** Update a card partially */
export const updateCard =
    (cardId: string, partialCard: Partial<CardState>) =>
    (state: StoreState): StoreState => {
        const prevCard = state.cards[cardId];

        const newState = setPath(
            state,
            ['cards', cardId],
            mergeDeep(prevCard, partialCard)
        );

        return makeSurveyDirty(newState);
    };
